var parser = parser ?? new DOMParser();

window.cartFunctions = {
  animateProgressBar,
  replaceCartComponent,
  updateBubbleCount,
  addFreeProduct,
  removeFreeProduct,
  updateCartDrawer,
  removeAllGiftsFromSettings,
};

const cartSectionsList = [
  "#CartDrawer-CartItems",
  ".gb-discounts-cart-values",
  ".discount-banner",
  ".free-product-progress-bar-successfull",
];

const cartSectionsToRenderList = [
  {
    id: "CartDrawer",
    section: "cart-drawer",
    selector: ".drawer__inner",
  },
  {
    id: "cart-icon-bubble",
    section: "cart-icon-bubble",
    selector: ".shopify-section",
  },
];

function getCartDrawerState() {
  const cartDrawerRoot = document.querySelector("cart-drawer");
  const cartDrawer = document.getElementById("CartDrawer");
  const overlay = document.getElementById("CartDrawer-Overlay");
  const inner = cartDrawer?.querySelector(".drawer__inner");

  return {
    shouldStayOpen: Boolean(
      cartDrawerRoot?.classList.contains("active") ||
      cartDrawer?.classList.contains("active") ||
      overlay?.classList.contains("active") ||
      inner?.classList.contains("active") ||
      cartDrawer?.hasAttribute("open")
    ),
  };
}

function restoreCartDrawerState(shouldStayOpen) {
  const cartDrawerRoot = document.querySelector("cart-drawer");
  const cartDrawer = document.getElementById("CartDrawer");
  const overlay = document.getElementById("CartDrawer-Overlay");
  const inner = cartDrawer?.querySelector(".drawer__inner");

  if (!shouldStayOpen) {
    if (typeof window.syncThemeCartScrollLock === "function") {
      window.syncThemeCartScrollLock();
    }
    return;
  }

  if (cartDrawerRoot) cartDrawerRoot.classList.add("active");
  if (cartDrawer) {
    cartDrawer.classList.add("active");
    cartDrawer.setAttribute("open", "");
    cartDrawer.setAttribute("aria-hidden", "false");
  }
  if (overlay) overlay.classList.add("active");
  if (inner) inner.classList.add("active");

  if (typeof window.syncThemeCartScrollLock === "function") {
    window.syncThemeCartScrollLock();
  }
}

function dispatchCartDrawerRefreshEvents() {
  document.dispatchEvent(new CustomEvent("cart:updated"));
  document.dispatchEvent(new CustomEvent("cart:refresh"));

  if (
    window.CartDrawerSubscriptionUI &&
    typeof window.CartDrawerSubscriptionUI.init === "function"
  ) {
    window.CartDrawerSubscriptionUI.init();
  }

  if (
    window.CartDrawerProgressConfetti &&
    typeof window.CartDrawerProgressConfetti.init === "function"
  ) {
    window.CartDrawerProgressConfetti.init();
  }

  if (
    window.CartDrawerCuratedUpsells &&
    typeof window.CartDrawerCuratedUpsells.init === "function"
  ) {
    window.CartDrawerCuratedUpsells.init();
  }
}

function finalizeCartDrawerDomUpdate(shouldStayOpen) {
  restoreCartDrawerState(shouldStayOpen);
  detectDiscountWrap();
  dispatchCartDrawerRefreshEvents();

  if (typeof window.syncThemeCartScrollLock === "function") {
    window.syncThemeCartScrollLock();
    setTimeout(window.syncThemeCartScrollLock, 30);
    setTimeout(window.syncThemeCartScrollLock, 120);
  }
}


function removeAllGiftsFromSettings(callbackFn) {
  if (!freeGiftProductIds) return;

  const cartDrawerContainer = document.querySelector("cart-drawer");
  if (!cartDrawerContainer) {
    console.error("Cart drawer not found.");
    if (callbackFn) callbackFn();
    return;
  }

  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const giftItems = cart.items.filter(
        (item) =>
          item.price === 0 && freeGiftProductIds.includes(`${item.product_id}`)
      );

      if (giftItems.length === 0) {
        if (callbackFn) callbackFn();
        return;
      }

      const updates = {};
      giftItems.forEach((gift) => {
        updates[gift.key] = 0;
      });

      return fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates,
          sections: cartSectionsToRenderList.map((s) => s.section),
          sections_url: window.location.pathname,
        }),
      });
    })
    .then((res) => res?.text())
    .then((state) => {
      if (!state) return;

      const parsedState = JSON.parse(state);
      const newCartDrawer = parser
        .parseFromString(parsedState.sections["cart-drawer"], "text/html")
        .querySelector("#CartDrawer");

      if (newCartDrawer) {
        const oldCart = document.querySelector("cart-drawer");
        updateCartDrawer(oldCart, newCartDrawer, false, callbackFn);

        const totalValueNode = newCartDrawer.querySelector(".gb-totals-total-value");
        const newTotalValue = parseInt(totalValueNode?.innerText ?? "0", 10);

        const variantInput = document.querySelector(
          "form.free-product-form .product-variant-id"
        );
        const freeProductId = variantInput ? variantInput.value : null;

        const thresholdNode = document.querySelector("[data-treshold-product]");
        const amountFreeProduct = thresholdNode
          ? thresholdNode.getAttribute("data-treshold-product")
          : null;

        if (
          newTotalValue < amountFreeProduct &&
          !!freeProductId &&
          typeof show_progress_bar !== "undefined" &&
          show_progress_bar
        ) {
          removeFreeProduct(oldCart);
        }
      } else if (callbackFn) {
        callbackFn();
      }
    })
    .catch((error) => {
      console.error("Error while deleting free gift product :", error);
      if (callbackFn) callbackFn();
    });
}

function removeFreeProduct(cartDrawer, callbackFn) {
  if (!cartDrawer || cartDrawer.classList.contains("is-empty")) return;

  const removeButtonElement = cartDrawer.querySelector("button.gb-remove-product");
  const removeBtn = removeButtonElement
    ? removeButtonElement.closest("cart-remove-button")
    : null;

  if (!removeBtn) {
    console.error("Can't find remove button of the free product");
    if (callbackFn) callbackFn();
    return;
  }

  const cartIndex = removeBtn.dataset.index;
  const body = JSON.stringify({
    line: cartIndex,
    quantity: 0,
    sections: cartSectionsToRenderList.map((_item) => _item.section),
    sections_url: window.location.pathname,
  });

  fetch(window.routes.cart_change_url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body,
  })
    .then((response) => response.text())
    .then((state) => {
      const parsedState = JSON.parse(state);
      const cartItemsCount = parsedState.item_count;

      updateBubbleCount(cartItemsCount);

      if (cartItemsCount == 0) {
        const parserInstance = new DOMParser();
        cartDrawer.classList.toggle("is-empty", cartItemsCount === 0);

        const oldCartDrawer =
          cartDrawer.querySelector("#CartDrawer") ?? cartDrawer;
        const newCartDrawer = parserInstance
          .parseFromString(parsedState.sections["cart-drawer"], "text/html")
          .querySelector("#CartDrawer");

        replaceCartComponent(oldCartDrawer, newCartDrawer);
        if (callbackFn) callbackFn();
        return;
      }

      if (parsedState.errors) {
        const cartStatus =
          document.getElementById("cart-live-region-text") ||
          document.getElementById("CartDrawer-LiveRegionText");

        if (cartStatus) {
          cartStatus.setAttribute("aria-hidden", false);
          setTimeout(() => {
            cartStatus.setAttribute("aria-hidden", true);
          }, 1000);
        }
        if (callbackFn) callbackFn();
        return;
      }

      const cartDrawerWrapper = document.querySelector("cart-drawer");
      const cartFooter = document.getElementById("main-cart-footer");

      if (cartFooter) {
        cartFooter.classList.toggle("is-empty", cartItemsCount === 0);
      }
      if (cartDrawerWrapper) {
        cartDrawerWrapper.classList.toggle("is-empty", cartItemsCount === 0);
      }

      cartSectionsToRenderList.forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id) ||
          document.querySelector(section.selector) ||
          document.getElementById(section.id);

        if (!elementToReplace) return;

        if (section.section == "cart-drawer") {
          const cartDrawerContainer = elementToReplace;
          const newCartDrawer = parser.parseFromString(
            parsedState.sections[section.section],
            "text/html"
          );

          updateCartDrawer(cartDrawerContainer, newCartDrawer, false);
        } else {
          const parsedSection = new DOMParser().parseFromString(
            parsedState.sections[section.section],
            "text/html"
          );
          const replacementNode = parsedSection.querySelector(section.selector);
          if (replacementNode) {
            elementToReplace.innerHTML = replacementNode.innerHTML;
          }
        }
      });

      if (callbackFn) callbackFn();
    })
    .catch((_err) => {
      console.error("Error________", _err);
      if (callbackFn) callbackFn();
    });
}

function animateProgressBar(progressBar, targetValue, duration = 500) {
  if (!progressBar) return;

  const startValue = progressBar.value;
  const startTime = performance.now();

  function updateProgress(currentTime) {
    const elapsedTime = currentTime - startTime;
    const progress = Math.min(elapsedTime / duration, 1);
    const easedProgress = 1 - Math.pow(1 - progress, 2);

    progressBar.value =
      startValue + (targetValue - startValue) * easedProgress;

    if (progress < 1) {
      requestAnimationFrame(updateProgress);
    }
  }

  requestAnimationFrame(updateProgress);
}

function replaceCartComponent(oldComponent, newComponent) {
  if (!oldComponent || !newComponent || !oldComponent.parentNode) return false;

  oldComponent.parentNode.replaceChild(newComponent, oldComponent);
  return true;
}

function updateBubbleCount(newTotalCount) {
  const normalizedCount = Number(newTotalCount || 0);
  const cartBubbleSpan = document.querySelector(".cart-count-bubble span");
  const customHeaderCount = document.querySelector(".sf-header__cart-count");
  const bubbleContainer = document.querySelector("#cart-icon-bubble");

  if (customHeaderCount) {
    customHeaderCount.textContent = normalizedCount;
    customHeaderCount.style.display = normalizedCount > 0 ? "inline-flex" : "none";
  }

  if (normalizedCount === 0 && cartBubbleSpan) {
    const cartBubbleContainer = cartBubbleSpan.parentNode;
    if (cartBubbleContainer) {
      cartBubbleContainer.innerHTML = "";
    }
  } else if (cartBubbleSpan) {
    cartBubbleSpan.innerText = normalizedCount;
  } else if (bubbleContainer && normalizedCount > 0) {
    const bubbleIcon = document.createElement("div");
    bubbleIcon.classList.add("cart-count-bubble");
    bubbleIcon.style.backgroundColor = "var(--global-section-text-color)";
    bubbleIcon.style.color = "var(--global-section-background-color)";
    bubbleIcon.innerHTML = `<span aria-hidden="true">${normalizedCount}</span>`;
    bubbleContainer.appendChild(bubbleIcon);
  }
}

async function addFreeProduct(cartDrawer, callbackFn) {
  const form = document.querySelector("form.free-product-form");
  if (!form) {
    if (callbackFn) callbackFn();
    return;
  }

  const formData = new FormData(form);
  const freeProductInput = document.querySelector(
    "form.free-product-form .product-variant-id"
  );
  const freeProductId = freeProductInput ? freeProductInput.value : null;

  if (!freeProductId) {
    if (callbackFn) callbackFn();
    return;
  }

  try {
    const response = await fetch(window.routes.cart_add_url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
    });

    if (response.ok) {
      fetch(window.routes.cart_url + "?view=drawer")
        .then((response) => response.text())
        .then((html) => {
          const parsedCartHtml = parser.parseFromString(html, "text/html");
          const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");

          if (newCartDrawer) {
            updateCartDrawer(cartDrawer, newCartDrawer, false, callbackFn);
          } else if (callbackFn) {
            callbackFn();
          }
        });
    } else if (callbackFn) {
      callbackFn();
    }
  } catch (_err) {
    console.error("Error while adding free product", _err);
    if (callbackFn) callbackFn();
  }
}

function updateCartDrawer(
  oldCartDrawer,
  newCartDrawer,
  checkFreeProduct = true,
  callbackFn
) {
  if (!oldCartDrawer || !newCartDrawer) {
    if (callbackFn) callbackFn();
    return;
  }

  const shouldStayOpen = getCartDrawerState().shouldStayOpen;

  const cartDrawerContainer =
    oldCartDrawer.closest("cart-drawer") ?? oldCartDrawer;
  const cartDrawer =
    cartDrawerContainer.querySelector("#CartDrawer") ?? cartDrawerContainer;

  const incomingCartDrawer =
    newCartDrawer.id === "CartDrawer"
      ? newCartDrawer
      : newCartDrawer.querySelector("#CartDrawer") ?? newCartDrawer;

  const variantInput = document.querySelector(
    "form.free-product-form .product-variant-id"
  );
  const freeProductId = variantInput ? variantInput.value : null;

  const oldTotalCountNode = cartDrawerContainer.querySelector(".gb-cart-total-item");
  const newTotalCountNode = incomingCartDrawer.querySelector(".gb-cart-total-item");

  const oldTotalCount = oldTotalCountNode ? oldTotalCountNode.textContent : "0";
  const newTotalCount = newTotalCountNode ? newTotalCountNode.textContent : "0";

  if (newTotalCount == "" || newTotalCount == "0") {
    cartDrawerContainer.classList.add("is-empty");
    replaceCartComponent(cartDrawer, incomingCartDrawer);
    updateBubbleCount(newTotalCount);
    finalizeCartDrawerDomUpdate(shouldStayOpen);
    if (callbackFn) callbackFn();
    return;
  }

  if (oldTotalCount == "" || oldTotalCount == "0") {
    const totalValueNode = incomingCartDrawer.querySelector(".gb-totals-total-value");
    const newTotalValue = parseInt(totalValueNode?.innerText ?? "0", 10);

    const newFreeProduct = incomingCartDrawer.querySelector(
      ".gb-find-remove-product.cart-item"
    );

    const thresholdNode = document.querySelector("[data-treshold-product]");
    const amountFreeProduct = thresholdNode
      ? thresholdNode.getAttribute("data-treshold-product")
      : null;

    if (
      newTotalValue >= amountFreeProduct &&
      newFreeProduct == null &&
      !!freeProductId &&
      typeof show_progress_bar !== "undefined" &&
      show_progress_bar
    ) {
      addFreeProduct(cartDrawerContainer, callbackFn);
    } else {
      cartDrawerContainer.classList.remove("is-empty");
      replaceCartComponent(cartDrawer, incomingCartDrawer);
      updateBubbleCount(newTotalCount);
      finalizeCartDrawerDomUpdate(shouldStayOpen);
      if (callbackFn) callbackFn();
    }
    return;
  }

  const oldCountTarget = cartDrawerContainer.querySelector(".gb-cart-total-item");
  if (oldCountTarget) {
    oldCountTarget.innerText = newTotalCount;
  }

  const totalValueNode = incomingCartDrawer.querySelector(".gb-totals-total-value");
  const newTotalValue = parseInt(totalValueNode?.innerText ?? "0", 10);

  if (typeof show_progress_bar !== "undefined" && show_progress_bar) {
    const progressbar = cartDrawerContainer.querySelector(
      ".free-product-progress-bar-main progress"
    );

    const footerTotalNode = document.querySelector(
      ".cart-drawer__footer .gb-totals-total-value"
    );

    const startValue =
      progressbar?.value ?? parseInt(footerTotalNode?.innerText ?? "0", 10);

    animateProgressBar(progressbar, newTotalValue, 1000);
    colorSVG(cartDrawerContainer, startValue, newTotalValue);
  }

  const currentFreeProduct = cartDrawerContainer.querySelector(
    ".gb-find-remove-product.cart-item"
  );

  const thresholdNode = document.querySelector("[data-treshold-product]");
  const amountFreeProduct = thresholdNode
    ? thresholdNode.getAttribute("data-treshold-product")
    : null;

  if (
    newTotalValue >= amountFreeProduct &&
    currentFreeProduct == null &&
    checkFreeProduct &&
    !!freeProductId &&
    typeof show_progress_bar !== "undefined" &&
    show_progress_bar
  ) {
    addFreeProduct(cartDrawerContainer, callbackFn);
  } else if (
    newTotalValue < amountFreeProduct &&
    currentFreeProduct != null &&
    checkFreeProduct &&
    !!freeProductId &&
    typeof show_progress_bar !== "undefined" &&
    show_progress_bar
  ) {
    removeFreeProduct(cartDrawerContainer, callbackFn);
  } else {
    cartSectionsList.forEach((selector) => {
      const element = cartDrawerContainer.querySelector(selector);
      const newElement = incomingCartDrawer.querySelector(selector);
      replaceCartComponent(element, newElement);
    });

    const footerTotals = cartDrawerContainer.querySelector(".drawer__footer .gb-totals-total-value");
    const incomingFooterTotals = incomingCartDrawer.querySelector(
      ".drawer__footer .gb-totals-total-value"
    );
    if (footerTotals && incomingFooterTotals) {
      footerTotals.textContent = incomingFooterTotals.textContent;
    }

    const liveTotalPrice = cartDrawerContainer.querySelector(".drawer__footer .totals__total-value");
    const incomingLiveTotalPrice = incomingCartDrawer.querySelector(
      ".drawer__footer .totals__total-value"
    );
    if (liveTotalPrice && incomingLiveTotalPrice) {
      liveTotalPrice.innerHTML = incomingLiveTotalPrice.innerHTML;
    }

    updateBubbleCount(newTotalCount);
    finalizeCartDrawerDomUpdate(shouldStayOpen);
    if (callbackFn) callbackFn();
  }
}

function detectDiscountWrap() {
  const container = document.querySelector(
    ".cart-drawer .discount_price-container"
  );
  const discount = container?.querySelector(".discount_discount-value");
  const price = container?.querySelector(".totals__total-value");

  if (!container || !discount || !price) return;

  const discountTop = discount.getBoundingClientRect().top;
  const priceTop = price.getBoundingClientRect().top;

  if (discountTop + 5 < priceTop) {
    container.classList.add("wrap");
  } else {
    container.classList.remove("wrap");
  }
}

function colorSVG(cartDrawerContainer, startValue, newTotalValue) {
  if (!cartDrawerContainer) return;

  const freeProductSvg = cartDrawerContainer.querySelector(
    ".free-product-progress-bar-main .free-gift-main"
  );
  const freeShipSvg = cartDrawerContainer.querySelector(
    ".free-product-progress-bar-main .free-shipping-main"
  );

  const thresholdNode = document.querySelector("[data-treshold-product]");
  const amountFreeProduct = thresholdNode
    ? thresholdNode.getAttribute("data-treshold-product")
    : null;

  if (freeProductSvg) {
    if (startValue < amountFreeProduct && newTotalValue >= amountFreeProduct) {
      freeProductSvg.classList.add("free-gift-main-color");
    } else if (
      startValue >= amountFreeProduct &&
      newTotalValue < amountFreeProduct
    ) {
      freeProductSvg.classList.remove("free-gift-main-color");
    }
  }

  if (
    freeShipSvg &&
    typeof free_shipping_price !== "undefined" &&
    startValue < free_shipping_price &&
    newTotalValue >= free_shipping_price
  ) {
    freeShipSvg.classList.add("free-shipping-main-color");
  } else if (
    freeShipSvg &&
    typeof free_shipping_price !== "undefined" &&
    startValue >= free_shipping_price &&
    newTotalValue < free_shipping_price
  ) {
    freeShipSvg.classList.remove("free-shipping-main-color");
  }
}

function startLoading(buttonElem) {
  if (!buttonElem) return;

  const spinAnim = buttonElem.querySelector(".spin-animation");
  const contentElem = buttonElem.querySelector(".content");

  if (spinAnim) spinAnim.style.display = "block";
  if (contentElem) contentElem.style.display = "none";
}

function stopLoading(buttonElem) {
  if (!buttonElem) return;

  const spinAnim = buttonElem.querySelector(".spin-animation");
  const contentElem = buttonElem.querySelector(".content");

  if (spinAnim) spinAnim.style.display = "none";
  if (contentElem) contentElem.style.display = "block";
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const removeButton = event.target.closest("button.cart-remove-button");
      startLoading(removeButton);

      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");

      if (cartItems) {
        cartItems.updateQuantity(this.dataset.index, 0, event);
      } else {
        stopLoading(removeButton);
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        return this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input =
      this.querySelector(`#Quantity-${id}`) ||
      this.querySelector(`#Drawer-quantity-${id}`);

    if (input) {
      input.value = input.getAttribute("value");
    }

    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    if (!event.target) return;

    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event, callbackFn) {
    const inputValue = parseInt(event.target.value, 10);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < parseInt(event.target.dataset.min, 10)) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (
      event.target.max &&
      inputValue > parseInt(event.target.max, 10)
    ) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step, 10) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
      if (callbackFn) callbackFn();
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();

      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement?.getAttribute("name"),
        event.target.dataset.quantityVariantId,
        callbackFn
      );
    }
  }

  onChange(event) {
    const buttonType = event.detail?.buttonType;
    const quantityInput = event.target.closest(".cart-quantity");
    if (!quantityInput) return;

    const curButton = quantityInput.querySelector(`[name='${buttonType}']`);

    if (curButton) {
      startLoading(curButton);
      this.validateQuantity(event, () => stopLoading(curButton));
    } else {
      this.validateQuantity(event);
    }
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const cartDrawerContainer = document.querySelector("cart-drawer");
          const newCartDrawer = html.querySelector("#CartDrawer");
          updateCartDrawer(cartDrawerContainer, newCartDrawer);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          if (sourceQty) {
            this.innerHTML = sourceQty.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    const mainCartItems = document.getElementById("main-cart-items");
    const mainCartFooter = document.getElementById("main-cart-footer");

    return [
      ...(mainCartItems
        ? [
            {
              id: "main-cart-items",
              section: mainCartItems.dataset.id,
              selector: ".js-contents",
            },
          ]
        : []),
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      ...(mainCartFooter
        ? [
            {
              id: "main-cart-footer",
              section: mainCartFooter.dataset.id,
              selector: ".js-contents",
            },
          ]
        : []),
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: "#CartDrawer",
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId, callbackFn) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    const eventTarget =
      event.currentTarget instanceof CartRemoveButton ? "clear" : "change";

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (
          typeof relyOnProductId !== "undefined" &&
          !parsedState.items.some((item) => item.product_id == relyOnProductId) &&
          parsedState.items_removed?.[0]?.product_id == relyOnProductId
        ) {
          removeAllGiftsFromSettings();
        }

        CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) ||
            document.getElementById(`Drawer-quantity-${line}`);

          const items = document.querySelectorAll(".cart-item");

          if (parsedState.errors) {
            if (quantityElement) {
              quantityElement.value = quantityElement.getAttribute("value");
            }
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle("is-empty", parsedState.item_count === 0);

          const cartDrawerWrapper = document.querySelector("cart-drawer");
          const cartFooter = document.getElementById("main-cart-footer");

          if (cartFooter) {
            cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
          }

          if (cartDrawerWrapper) {
            cartDrawerWrapper.classList.toggle(
              "is-empty",
              parsedState.item_count === 0
            );
          }

          const shouldStayOpen = getCartDrawerState().shouldStayOpen;

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id) ||
              document.querySelector(section.selector) ||
              document.getElementById(section.id);

            if (!elementToReplace) return;

            if (section.section == "cart-drawer") {
              const cartDrawerContainer = document.querySelector("cart-drawer");
              const newCartDrawerContainer = parser.parseFromString(
                parsedState.sections[section.section],
                "text/html"
              );

              const newCartDrawer =
                newCartDrawerContainer.getElementById(section.id) ||
                newCartDrawerContainer.querySelector(section.selector) ||
                newCartDrawerContainer.getElementById(section.id);

              updateCartDrawer(cartDrawerContainer, newCartDrawer);
            } else {
              const sectionHtml = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );

              if (typeof sectionHtml === "string") {
                elementToReplace.innerHTML = sectionHtml;
              }
            }
          });

          const updatedValue = parsedState.items[line - 1]
            ? parsedState.items[line - 1].quantity
            : undefined;

          restoreCartDrawerState(shouldStayOpen);
          detectDiscountWrap();
          dispatchCartDrawerRefreshEvents();

          let message = "";

          if (
            quantityElement &&
            items.length === parsedState.items.length &&
            updatedValue !== parseInt(quantityElement.value, 10)
          ) {
            if (typeof updatedValue === "undefined") {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace(
                "[quantity]",
                updatedValue
              );
            }
          }

          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) ||
            document.getElementById(`CartDrawer-Item-${line}`);

          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            if (cartDrawerWrapper) {
              trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              );
            } else {
              lineItem.querySelector(`[name="${name}"]`).focus();
            }
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            const emptyInner = cartDrawerWrapper.querySelector(".drawer__inner-empty");
            const emptyLink = cartDrawerWrapper.querySelector("a");
            if (emptyInner && emptyLink) {
              trapFocus(emptyInner, emptyLink);
            }
          } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
            const firstCartItemName = document.querySelector(".cart-item__name");
            if (firstCartItemName) {
              trapFocus(cartDrawerWrapper, firstCartItemName);
            }
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch((err) => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) => {
          overlay.classList.add("hidden");
        });

        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");

        if (errors) {
          errors.textContent = window.cartStrings.error;
        }

        console.error(err);
      })
      .finally(() => {
        try {
          this.disableLoading(line);
        } catch (err) {
          console.error("disableLoading error:", err);
        }

        try {
          if (callbackFn) callbackFn();
        } catch (err) {
          console.error("callbackFn error:", err);
        }
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (lineItemError && !!message) {
      const errorText = lineItemError.querySelector(".cart-item__error-text");
      if (errorText) {
        errorText.textContent = message;
      }

      lineItemError.style.display = "block";
      lineItemError.style.marginBottom = "12px";

      setTimeout(() => {
        lineItemError.style.display = "none";
        lineItemError.style.marginBottom = "0";
      }, 4000);
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute("aria-hidden", true);
    }

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");

    if (cartStatus) {
      cartStatus.setAttribute("aria-hidden", false);

      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const element = parsed.querySelector(selector);
    return element ? element.innerHTML : "";
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");

    if (mainCartItems) {
      mainCartItems.classList.add("cart__items--disabled");
    }

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => {
      if (overlay) overlay.classList.remove("hidden");
    });

    if (
      document.activeElement &&
      typeof document.activeElement.blur === "function"
    ) {
      document.activeElement.blur();
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");

    if (mainCartItems) {
      mainCartItems.classList.remove("cart__items--disabled");
    }

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => {
      if (overlay) overlay.classList.add("hidden");
    });

    const quantityButtons = this.querySelectorAll(
      `#CartItem-${line} .quantity__button, #CartDrawer-Item-${line} .quantity__button`
    );
    quantityButtons.forEach((button) => stopLoading(button));

    const removeButtons = this.querySelectorAll(
      `#CartItem-${line} .cart-remove-button, #CartDrawer-Item-${line} .cart-remove-button`
    );
    removeButtons.forEach((button) => stopLoading(button));
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });

            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            }).then(() =>
              CartPerformance.measureFromEvent("note-update:user-action", event)
            );
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
